/**
 * This is an implementation of the <a href="https://sourcemaking.com/design_patterns/observer">Observer pattern</a>
 */
export default class Observer<EVENT_TYPE> {
	private handlers: Array<(event: EVENT_TYPE) => any>;

	/**
	 * Initialize an {@link Observer} with the given EVENT_TYPE argument
	 */
	constructor() {
		this.handlers = [];
	}

	/**
	 * Subscribe a handler to this observer
	 */
	public subscribe(fn: (event: EVENT_TYPE) => any): void {
		this.handlers.push(fn);
	}

	/**
	 * Unsubscribe a handler from this observer
	 */
	public unsubscribe(fn: (event: EVENT_TYPE) => any): void {
		this.handlers = this.handlers.filter((item: (event: EVENT_TYPE) => any) => {
			return (item !== fn) ? item : null;
		});
	}

	/**
	 * Notify all handlers for a given event type
	 */
	public notify(event: EVENT_TYPE): void {
		for (let handler of this.handlers) {
			handler(event);
		}
	}

	/**
	 * disconnect all handlers
	 */
	public disconnect(): void {
		this.handlers = [];
	}
}